const resources = { showMore: 'Afficher plus' };

module.exports = function getResource(label) {
    return resources[label];
};
